// extracted by mini-css-extract-plugin
export var infoItem = "_qx-2";
export var title = "_qx-0";
export var value = "_qx-1";